import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { css } from "styled-components";

sizeVariantValues.default = {
    ...sizeVariantValues.default,
    fontSize: 18,
    height: 50,
    borderRadius: 4,
} as any;

sizeVariantValues.small = {
    ...sizeVariantValues.small,
    fontSize: 16,
    height: 30,
    borderRadius: 4,
} as any;
